import script from "./zjls.vue?vue&type=script&setup=true&lang=js"
export * from "./zjls.vue?vue&type=script&setup=true&lang=js"

import "./zjls.vue?vue&type=style&index=0&id=94a94d2a&lang=scss&scoped=true"

import exportComponent from "D:\\liu\\jmzc\\jimuERPVUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-94a94d2a"]])

export default __exports__